import { render, staticRenderFns } from "./aOrderDetailLedgers.vue?vue&type=template&id=3da7d7eb&scoped=true"
import script from "./aOrderDetailLedgers.vue?vue&type=script&lang=js"
export * from "./aOrderDetailLedgers.vue?vue&type=script&lang=js"
import style0 from "./aOrderDetailLedgers.vue?vue&type=style&index=0&id=3da7d7eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da7d7eb",
  null
  
)

export default component.exports